import React from 'react';
import Typography from '@material-ui/core/Typography';
export default function Contributors() {
  return (
    <div>  
    <Typography variant="h6">
      Contributors
    </Typography>
    </div>
  );
}
